
import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
export default function TopDestinations() {
    const navigate = useNavigate();
  const destinations = [
    {
      name: "Impact Stories ",
      image: "/assets/img14.png",
      route: "/testimonials",
    },
    {
      name: "Program Intervention ",
      image: "/assets/img6.jpg",
      route: "/impact",
    },
    {
      name: "Career Expo",
      image: "/assets/img11.jpg",
      route: "/events",
    },
    {
      name: "Our Partners",
      image: "/assets/img12.jpg",
      route: "/partners",
    },
  ];

  return (
    <section className="bg-gray-100 py-16 ">
      <motion.div
        className="container mx-auto px-14 "
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        <motion.h2
          className="text-3xl font-bold text-orange mb-4 mt-8 text-center"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
         The Dereja Journey Showcase
        </motion.h2>
        <hr
          className="w-1/6 mx-auto mb-10"
          style={{
            border: "none",
            borderTop: "2px dashed",
            borderImage: "linear-gradient(to right, #ffffff, #4d0000) 1",
            height: "0",
          }}
        />
        <motion.h3
          className="text-2xl font-bold text-gray-800 mb-8"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
         Visualizing Success
        </motion.h3>
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
          {destinations.map((destination, index) => (
            <motion.div
              key={index}
              className="relative h-60 w-full overflow-hidden rounded-lg shadow-lg group"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ type: "spring", duration: 0.6, delay: index * 0.2 }}
              whileHover={{ scale: 1.05 }}
              viewport={{ once: true }}
              onClick={() => destination.route && navigate(destination.route)}
            >
              {/* Background Image */}
              <img
                src={destination.image}
                alt={destination.name}
                className="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-110"
              />

             
              <div className="absolute inset-0 bg-black opacity-30 group-hover:opacity-50 transition-opacity duration-300"></div>

              
              <div className="absolute inset-0 flex items-center justify-center">
                <h4 className="text-white text-lg font-semibold transition-opacity duration-300 group-hover:opacity-100">
                  {destination.name}
                </h4>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
